const DEFAULT_ID_KEYS = ["_id", "id", "quotationId", "projectid", "projectId"];

const normalizeIncomingList = (list) => (Array.isArray(list) ? list : []);

const getItemId = (item, idKeys = DEFAULT_ID_KEYS) => {
  if (!item || typeof item !== "object") return undefined;
  for (const key of idKeys) {
    if (item[key] !== undefined && item[key] !== null) return item[key];
  }
  return undefined;
};

const isSameEntity = (a, b, idKeys = DEFAULT_ID_KEYS) => {
  const aId = getItemId(a, idKeys);
  const bId = getItemId(b, idKeys);
  if (aId !== undefined && bId !== undefined) return aId === bId;
  return false;
};

export const updateItemInList = (list, incomingItem, options = {}) => {
  const { idKeys = DEFAULT_ID_KEYS } = options;
  if (!incomingItem || typeof incomingItem !== "object") return normalizeIncomingList(list);

  const safeList = normalizeIncomingList(list);
  const incomingId = getItemId(incomingItem, idKeys);
  if (incomingId === undefined) return safeList;

  let updated = false;
  const next = safeList.map((item) => {
    if (isSameEntity(item, incomingItem, idKeys)) {
      updated = true;
      return { ...item, ...incomingItem };
    }
    return item;
  });

  return updated ? next : safeList;
};

export const addItemToList = (list, incomingItem, options = {}) => {
  const { idKeys = DEFAULT_ID_KEYS, prepend = true } = options;
  if (!incomingItem || typeof incomingItem !== "object") return normalizeIncomingList(list);

  const safeList = normalizeIncomingList(list);
  const incomingId = getItemId(incomingItem, idKeys);
  if (incomingId === undefined) return safeList;

  const exists = safeList.some((item) => isSameEntity(item, incomingItem, idKeys));
  if (exists) return safeList;

  return prepend ? [incomingItem, ...safeList] : [...safeList, incomingItem];
};

export const removeItemFromList = (list, incomingItemOrId, options = {}) => {
  const { idKeys = DEFAULT_ID_KEYS } = options;
  const safeList = normalizeIncomingList(list);
  if (!safeList.length) return safeList;

  const incomingId =
    typeof incomingItemOrId === "object"
      ? getItemId(incomingItemOrId, idKeys)
      : incomingItemOrId;

  if (incomingId === undefined || incomingId === null) return safeList;

  return safeList.filter((item) => {
    const itemId = getItemId(item, idKeys);
    return itemId !== incomingId;
  });
};

export const getRealtimeEntityFromPayload = (data) => {
  if (!data) return null;
  if (Array.isArray(data)) return data[0] || null;
  if (typeof data !== "object") return null;
  if (Array.isArray(data.data)) return data.data[0] || null;
  if (Array.isArray(data.items)) return data.items[0] || null;
  if (data.data && typeof data.data === "object") return data.data;
  return data;
};

export const isModuleMatch = (incomingModule, acceptedModules = []) => {
  const normalized = `${incomingModule || ""}`.toLowerCase().trim();
  if (!normalized) return false;
  return acceptedModules.some(
    (moduleName) => `${moduleName || ""}`.toLowerCase().trim() === normalized
  );
};
